<template>
  <table class="w-100 form-submission-table text-left">
    <tbody>
      <template v-for="group in groups">
        <tr
          :key="`title-${group.id}`"
          class="form-submission-table__group-title form-submission-table__row"
        >
          <td class="py-2 pl-2 pr-1" colspan="3">
            {{ group.title }}
          </td>
        </tr>

        <template v-if="isPresent(group.form_fields)">
          <form-submission-row
            class="form-submission-table__row"
            v-for="field in group.form_fields"
            :key="field.id"
            :field="field"
            :field-group="group"
            :values="values"
            :is-missable="isMissable"
            @input="vs => $emit('input', vs)"
          />
        </template>

        <template v-if="isPresent(group.form_groups)">
          <form-submission-row
            class="form-submission-table__row"
            v-for="group in group.form_groups"
            :key="group.id"
            :group="group"
            :values="values"
            :is-missable="isMissable"
            @input="updatedValues => $emit('input', updatedValues)"
          />
        </template>
      </template>
    </tbody>
  </table>
</template>

<script>
import FormSubmissionRow from "@/components/FormSubmissionRow"

import { isPresent } from "@/lib/utils"

export default {
  components: {
    FormSubmissionRow
  },

  model: {
    prop: "values",
    event: "input"
  },

  props: {
    groups: { type: Array, required: true },
    values: { type: Object, default: () => ({}) }, // form_field_id => value
    isMissable: { type: Boolean, default: false }
  },

  methods: {
    isPresent
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.form-submission-table {
  border-collapse: collapse;
}

.form-submission-table__row {
  border-top: 1px solid $color-ui--grey-20;
  vertical-align: top;
  font-size: $font-size--small;

  .space-pre {
    white-space: pre-wrap;
  }
}

.form-submission-table__group-title {
  background-color: $color-ui--grey-10;
  font-weight: bold;
}
</style>
